export interface UserGroup {
  groupId: string;
  groupName: string;
  domainAccess?: boolean;
  inviteAccess?: boolean;
}

export interface UserDeal {
  dealId: string;
  dealName: string;
  groups: UserGroup[];
  allProducts: boolean;
}

export enum UserCreatedViaType {
  DomainValidation = 'DomainValidation',
  EmailInvite = 'EmailInvite',
}

export interface User {
  id?: string;
  personId?: number;
  deals: UserDeal[];
  personName: string;
  email: string;
  phoneNumber?: string;
  phoneCountryCode: string;
  phoneCountryCodeId: string;
  phone?: User2FAPhoneNumberModel;
  assignedProducts: {
    assignmentId: number;
    name: string;
    quantityRedeemed: number;
    sku: string;
  }[];
  createdDate: string;
  createdByPersonId?: number;
  createdByPersonFullName: string;
  lastValidationDate: string;
  invitationCode?: string;
  isRemoved?: boolean;
  removedDate?: string;
  hasAcceptedToShareData?: boolean;
  dateRegistered: string;
  failedEmailDate?: string;
  failedEmailType?: string;
  failedEmailReason?: string;
  hasFailedEmail?: boolean;
  invitationStatus?: string;
  countryCode?: string;
  accountId: number;
  dataShareLogs: { logType: string; date: string }[];
  userCreatedVia: UserCreatedViaType;
}

export type DealUser = Omit<User, 'userId' | 'name' | 'lastLogin'> & {
  personName: string;
};

export interface UserQueryResult {
  currentPage: number;
  pageSize: number;
  pageCount: number;
  totalItemCount: number;
  items: User[];
}

export interface User2FAPhoneNumberModel {
  countryCodeId?: string;
  countryCode?: string;
  number?: string;
}

/* eslint-disable camelcase */

export interface JwtDecodedUser {
  id: string;
  given_name: string;
  family_name: string;
  b2b_aid?: string;
  b2b_auid?: string;
  email?: string;
  person_id?: number;
  rbac_2fa_raids?: string;
}
